import { render, staticRenderFns } from "./dashboardDonations.vue?vue&type=template&id=69d9353e&scoped=true&"
import script from "./dashboardDonations.vue?vue&type=script&lang=js&"
export * from "./dashboardDonations.vue?vue&type=script&lang=js&"
import style0 from "./dashboardDonations.vue?vue&type=style&index=0&id=69d9353e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69d9353e",
  null
  
)

export default component.exports